import React from 'react';

import { ReactComponent as RemoveIcon } from '../../../../assets/icons/filter-close.svg';
import { ReactComponent as FilterIcon } from '../../../../assets/icons/filter.svg';
import { ReactComponent as GridIcon } from '../../../../assets/icons/grid-list.svg';
import { ReactComponent as SettingsIcon } from '../../../../assets/icons/setting-icon.svg';
import MyButton from '../../../../shared-components/button/Button';
import CustomDateRangePicker from '../../../../shared-components/custom-date-range/CustomDateRangePicker';
import CustomPopover from '../../../../shared-components/custom-pop-over/CustomPopover';
import { permissionCheck } from '../../../../shared-functions/JWTDocodeFunction';

import DashboardFilter from './DashboardFilter';

interface DashboardToolbarProperties {
  onCustomize?: () => void;
  startDate: string;
  endDate: string;
  onDateRangeChange: (startDate: string, endDate: string) => void;
  onApply?: (filters: {
    facilityIds: string[];
    stationIds: string[];
    deviceIds: string[];
    type: string[];
  }) => void;
  onClear?: () => void;
  filters?: {
    facilityIds: string[];
    stationIds: string[];
    deviceIds: string[];
    type: string[];
  };
}

/**
 * DashboardToolbar component
 * Includes custom date range picker and action buttons (Customize, Filter, Settings)
 * @param {any} param0 - The param0
 * @param {any} param0.onCustomize - The onCustomize prop
 * @param {any} param0.startDate - The startDate prop
 * @param {any} param0.endDate - The endDate prop
 * @param {any} param0.onDateRangeChange - The onDateRangeChange prop
 * @param {any} param0.onApply - The onApply prop
 * @param {any} param0.onClear - The onClear prop
 * @param {any} param0.filters - The filters prop
 */
function DashboardToolbar({
  onCustomize,
  startDate,
  endDate,
  onDateRangeChange,
  onApply,
  onClear,
  filters,
}: DashboardToolbarProperties) {
  const hasActiveFilters =
    filters &&
    (filters.facilityIds.length > 0 ||
      filters.stationIds.length > 0 ||
      filters.deviceIds.length > 0);

  return (
    <div className="dashboard-toolbar-wrap">
      <div className="toolbar-left">
        <CustomDateRangePicker
          startDate={startDate}
          endDate={endDate}
          onChange={onDateRangeChange}
        />
      </div>
      <div className="toolbar-right">
        <div className="action-btn-group">
          <MyButton
            label="Customize Dashboard"
            buttonType="outline"
            svgIcon={<GridIcon />}
            // labelColorFill="var(--primary-color)"
            svgColorFill="var(--text-color)"
            onClickFunc={() => onCustomize?.()}
            disableButton={!permissionCheck('cpoCustomizeDashboardView')}
          />

          {hasActiveFilters && (
            <div className="badge">
              <MyButton
                label=""
                buttonType="outline"
                svgIcon={<RemoveIcon />}
                svgColorFill="var(--text-color)"
                onClickFunc={() => onClear?.()}
              />
            </div>
          )}
          <div className="badge-wrapper">
            <CustomPopover
              clickableElement={
                <MyButton
                  label=""
                  buttonType="outline"
                  svgIcon={<FilterIcon />}
                  svgColorFill="var(--text-color)"
                  onClickFunc={() => console.log('Filter')}
                />
              }
              popOverContent={<DashboardFilter onApply={onApply} initialFilters={filters} />}
            />
          </div>
          {false && (
            <div className="badge">
              <MyButton
                label=""
                buttonType="outline"
                svgIcon={<SettingsIcon />}
                svgColorFill="var(--text-color)"
                onClickFunc={() => console.log('Settings')}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

/**
 * Default props for DashboardToolbar component
 */
DashboardToolbar.defaultProps = {
  /**
   * Default props for DashboardToolbar component
   */
  onCustomize: () => {},
  /**
   * Default props for DashboardToolbar component
   */
  onApply: () => {},
  /**
   * Default props for DashboardToolbar component
   */
  onClear: () => {},
  /**
   * Default props for DashboardToolbar component
   */
  filters: undefined,
};

export default DashboardToolbar;
